module.exports = __webpack_public_path__ + "img/album14_23.68fe3dac.jpg";